import { render, staticRenderFns } from "./TeamMembersComponent.vue?vue&type=template&id=e5f20a82&scoped=true"
import script from "./TeamMembersComponent.vue?vue&type=script&lang=js"
export * from "./TeamMembersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f20a82",
  null
  
)

export default component.exports